'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var orgSelect = document.querySelector('#OrganizationId.organizations-select');
    var customerIdsSelect = document.querySelector('#CustomerIds.customers-select');
    if (orgSelect && customerIdsSelect) {
        $(orgSelect).on('select2:select', customerMessagesComboChange);
        $(customerIdsSelect).on('select2:select', customerMessagesComboChange);
    }

    var cmSavePlaceHolder = document.querySelector('.customer-message-save');
    if (cmSavePlaceHolder) registerSaveActions(cmSavePlaceHolder);

    function customerMessagesComboChange(event) {
        // if organization is changed, then clear all selected customers, but if is just removed, keep them
        if (event.target.id === 'OrganizationId') $('#CustomerIds').empty().trigger("change");

        var odataQuery = '';
        // omit selected customers
        var customersOptions = [].concat(_toConsumableArray(customerIdsSelect.selectedOptions));
        var index = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = customersOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var option = _step.value;

                odataQuery += (index > 0 ? ' and' : '') + ' id ne ' + option.value;
                index++;
            }
            // select only customers of selected organization
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        if (orgSelect.value) {
            odataQuery += (odataQuery.length > 0 ? ' and' : '') + ' organizationId eq ' + orgSelect.value;
        }
        customerIdsSelect.dataset.odataFilter = odataQuery;
    }

    function registerSaveActions(cmSavePlaceHolder) {
        var saveButton = cmSavePlaceHolder.querySelector('button.save-common');
        if (saveButton) saveButton.addEventListener('click', saveCustomerMessage);
        var saveAndCloseButton = cmSavePlaceHolder.querySelector('button.save-and-close');
        if (saveAndCloseButton) saveAndCloseButton.addEventListener('click', saveCustomerMessage);
    }

    function saveCustomerMessage(event) {
        var subject = getValueSafe('input#Subject');
        var subjectValidationElement = document.getElementById('subjectValidationMessage');

        if (subject.length === 0) {
            _notify2.default.warn(Resx.Validation.RequiredAttribute_ValidationError.replace('{0}', Resx.Common.Subject));
            if (subjectValidationElement) subjectValidationElement.style.display = 'block';
            return;
        } else if (subjectValidationElement) subjectValidationElement.style.display = 'none';

        var intRegex = /^[0-9]{1,20}$/;
        var organizationId = orgSelect.value;
        var customerIds = [].concat(_toConsumableArray(customerIdsSelect.selectedOptions)).filter(function (op) {
            return intRegex.test(op.value);
        }).map(function (o) {
            return parseInt(o.value);
        });

        var message = {
            Subject: subject,
            Body: $(".wysiwyg").ckeditor().val(),
            OrganizationId: intRegex.test(organizationId) ? parseInt(organizationId) : null,
            CustomerIds: customerIds
        };

        abp.services.api.customerMessages.insertMessage(message).done(function (result) {
            _notify2.default.success(Resx.App.SuccessfullySaved);
            var backButton = document.getElementById('back-button');
            if (!backButton) return;

            window.setTimeout(function () {
                window.location.href = backButton.href;
            }, 800);
        }).fail(function (result) {
            _notify2.default.error(Resx.Common.AjaxError);
        });
    }

    function getValueSafe(selector) {
        var element = document.querySelector(selector);
        return !!element ? $.trim(element.value) : '';
    }
};

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/Initializers/customerMessages.js
// module id = 405
// module chunks = 0